import { consoleLogger } from '@shared/logging/consoleLogger';
import { ConnectMessageType } from '@idConnect/types';
import { extractParametersFromAddress } from '@idConnect/helpers/extractParametersFromAddress';

export const isTroubleshootingUrl = () => {
  const allowedTroubleShootingDomains = [
    'https://service.test.utiq-aws.net',
    'https://service.utiq.com',
  ];

  const isTroubleshootingDomain = allowedTroubleShootingDomains.includes(
    (window.Utiq?.config)!.customUtiqHost!,
  );

  const { path } = extractParametersFromAddress(window.location.href);
  const allowedDomainPath = 'pages/troubleshooting';
  const isTroubleshootingDomainPath = path === allowedDomainPath;

  return isTroubleshootingDomain && isTroubleshootingDomainPath;
};

export const handleTroubleshootService = (): string => {
  const isTroubleshootingService = isTroubleshootingUrl();

  if (isTroubleshootingService) {
    consoleLogger.logDebug(
      `troubleshooting service url detected, no data will be returned`,
    );
  }

  return isTroubleshootingService ? '&diagnostic=true' : '';
};

export const isTroubleshootFlow = (
  msg: ConnectMessageType,
  template: string,
) => {
  if (!msg?.isTroubleShooting) {
    return false;
  }
  consoleLogger.logDebug(
    `troubleshooting flow detected on template handler ${template}, no data will be returned`,
  );
  return true;
};
